import React from "react";
import {
  FormLabel,
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";

const RadioButtonsGroup = ({
  isLabel,
  label,
  labelId,
  defaultValue,
  value,
  name,
  list,
  onChange,
  wrapperClass,
}) => {
  return (
    <FormControl>
      {isLabel && <FormLabel id={labelId}>{label}</FormLabel>}
      <RadioGroup
        aria-labelledby={labelId}
        value={value !== undefined ? value : (defaultValue ?? "")}
        name={name}
        onChange={onChange}
        className={wrapperClass}
      >
        {list?.map((item) => (
          <FormControlLabel
            value={item.value}
            key={item.id}
            control={<Radio />}
            label={item.label}
            id={item.id}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioButtonsGroup;
